// Firebase configuration for ReBusi
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

// Firebase config from environment variables (with fallbacks for development)
// Note: Firebase web config is designed to be public, but security rules must be configured
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBZOfi0PTG_rE1BJEoJ_dvKqif4qG7Pcsc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "rebusi-3fff9.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "rebusi-3fff9",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "rebusi-3fff9.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "657502486477",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:657502486477:web:e8804fea20845d32e34e84",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-0J2YYCHS4N"
};

// Initialize Firebase (singleton pattern)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);

// Set language to user's browser preference
auth.languageCode = 'en';

// FCM Messaging - initialized lazily
let messaging = null;

// VAPID key for FCM web push (generated from Firebase Console)
const VAPID_KEY = "BLBz8T8nKQXLgZJPRNJBkxvQEGtZqK5RYaF0SQb8xvhR5e_M1TJzKkXNqWvVJx-LGfHvB4lH5PYT8sKXr7sZrxY";

/**
 * Initialize FCM messaging
 */
export async function initializeMessaging() {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.log('FCM not supported in this browser');
      return null;
    }
    
    if (!messaging) {
      messaging = getMessaging(app);
    }
    return messaging;
  } catch (error) {
    console.error('Error initializing FCM:', error);
    return null;
  }
}

/**
 * Request notification permission and get FCM token
 */
export async function requestNotificationPermission() {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    const msg = await initializeMessaging();
    if (!msg) return null;

    // Register service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('Service Worker registered:', registration);

    // Get FCM token
    const token = await getToken(msg, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    console.log('FCM Token:', token);
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
}

/**
 * Listen for foreground messages
 */
export function onForegroundMessage(callback) {
  if (!messaging) {
    initializeMessaging().then((msg) => {
      if (msg) {
        onMessage(msg, callback);
      }
    });
  } else {
    onMessage(messaging, callback);
  }
}

export { app, auth, RecaptchaVerifier, signInWithPhoneNumber };
